"use client";

import React, { useCallback } from "react";
import { GoogleDriveBrowser } from "@/components/crm/drive/GoogleDriveBrowser";
import { ResponsiveModal, ModalContainer, MODAL_IDS } from "@wtc/ui";
import type { GoogleDriveFilePickerModalData } from "@/lib/modals/data/modal-data-types";

export function GoogleDriveFilePickerModal() {
  return (
    <ModalContainer<GoogleDriveFilePickerModalData> modalId={MODAL_IDS.files.googleDrivePicker}>
      {({ isOpen, data, onClose }) => (
        <GoogleDriveFilePickerModalContent
          isOpen={isOpen}
          data={data}
          onClose={onClose}
        />
      )}
    </ModalContainer>
  );
}

interface GoogleDriveFilePickerModalContentProps {
  isOpen: boolean;
  data?: GoogleDriveFilePickerModalData;
  onClose: () => void;
}

function GoogleDriveFilePickerModalContent({
  isOpen,
  data,
  onClose,
}: GoogleDriveFilePickerModalContentProps) {
  const onFileSelect = data?.onFileSelect;
  const email = data?.email;
  const isSecondAccount = data?.isSecondAccount ?? false;

  const handleFileSelect = useCallback((file: any) => {
    // Only allow file selection, not folders
    if (file.isFolder) {
      return;
    }

    onFileSelect?.(file);
  }, [onFileSelect]);

  return (
    <ResponsiveModal
      globalModalId={MODAL_IDS.files.googleDrivePicker}
      title="Select File from Google Drive"
      maxWidth="4xl"
    >
      <div className="space-y-4">
        <div className="text-sm text-muted-foreground">
          Browse your Google Drive to select a file to attach. Click on any file to attach it to
          your message.
        </div>

        <GoogleDriveBrowser
          email={email}
          isSecondAccount={isSecondAccount}
          onFileSelect={handleFileSelect}
          allowDownload={false}
          allowView={false}
          allowCreateFolder={false}
          allowUpload={false}
          compactMode={true}
          maxHeight="400px"
          className="border-0 shadow-none"
        />
      </div>
    </ResponsiveModal>
  );
}
